import React, { useCallback } from 'react'
import styled from 'styled-components'
import { MAX_DISPLAYED_WASTE_TYPES } from '../../core/application/constants'
import { WasteType } from '../../core/domain/models'
import ShowAllIcon from '../icons/ShowAllIcon'
import { WasteTypeIcon } from './index'

export interface IWasteTypeRowProps {
  wasteTypes: Array<WasteType>
  withShowAllButton: boolean
  onShowAll?: () => void
}

const WasteTypeRow: React.FC<IWasteTypeRowProps> = ({ wasteTypes, onShowAll, withShowAllButton }) => {
  const displayShowAll = withShowAllButton && wasteTypes.length > MAX_DISPLAYED_WASTE_TYPES

  const onShowAllClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      if (displayShowAll && onShowAll) {
        e.stopPropagation()
        onShowAll && onShowAll()
      }
    },
    [onShowAll, displayShowAll]
  )

  return (
    <Container>
      <GridContainer>
        {wasteTypes.slice(0, MAX_DISPLAYED_WASTE_TYPES).map((waste, index) => (
          <WasteTypeIcon key={index} name={waste.name} picture={waste.picture} showLabel />
        ))}
      </GridContainer>
      <ShowAllButton className={displayShowAll ? '' : 'hidden'} onClick={onShowAllClick}>
        <ShowAllIcon />
      </ShowAllButton>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`

const ShowAllButton = styled.button`
  cursor: pointer;

  &.hidden {
    visibility: hidden;
  }
`

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  flex-grow: 1;
`

export default WasteTypeRow
